import { z } from "zod";

import { createRequiredMessage } from "@/validations/message";
import { basicInfoSchema } from "@/validations/settings";

import { isJobIndustryRequired, ProfileSection } from "./profileCompletion";

const base = basicInfoSchema.innerType();
const personal = base.pick({
  family_name: true,
  first_name: true,
  family_name_kana: true,
  first_name_kana: true,
  birth_year: true,
  birth_month: true,
  phone_number: true,
  address_prefecture: true,
});
const investment = base.pick({
  interested_property_type_ids: true,
  consideration_period: true,
  past_meeting_count: true,
  considering_property: true,
  approved_financial_institutions: true,
  other_request_text: true,
});
const financial = base
  .pick({
    job_category: true,
    job_industry: true,
    job_continuous_period: true,
    annual_income: true,
    financial_asset: true,
    holding_property_count: true,
    real_estate_loan_amount: true,
    current_residence_type_id: true,
    home_loan_amount: true,
    monthly_rent_payment_amount: true,
  })
  .superRefine((data, context) => {
    const required = (key: string, message: string) =>
      context.addIssue({ code: z.ZodIssueCode.custom, path: [key], message });
    if (isJobIndustryRequired(data.job_category) && !data.job_industry)
      required("job_industry", "業種を選択してください。");
    if (Number(data.holding_property_count) > 0 && !data.real_estate_loan_amount)
      required("real_estate_loan_amount", "投資用不動産ローン合計を選択してください。");
    if (data.current_residence_type_id === 1 && !data.home_loan_amount)
      required("home_loan_amount", createRequiredMessage("住宅ローン残債"));
    if (data.current_residence_type_id === 2 && !data.monthly_rent_payment_amount)
      required("monthly_rent_payment_amount", createRequiredMessage("家賃"));
  });

export const profileSectionSchemas: Record<ProfileSection, z.ZodTypeAny> = { personal, financial, investment };
